import React from 'react';
import DegreeProgress from '../components/DegreeProgress';

export default function DegreeProgressPage() {
  return (
    <div className="min-h-screen bg-[#F9FAFB] text-gray-900 pb-10">
      <DegreeProgress />
    </div>
  );
}
